import { Variants } from "framer-motion";
import LeagueStandingPage from "pages/league/league";
import LeagueDetail from "pages/league/league-detail";
import LeaguePublic from "pages/league/leaguePublic";
import UserLeagueSchedule from "pages/league/schedule";
import PlayoffAllSchedule from "pages/league/schedule/AllSchedule";
import { createBrowserRouter, RouteObject } from "react-router-dom";
import RouteErrorPage from "./components/RouteErrorPage";
import ForgotPasswordPage from "./pages/auth/forgotPassword";
import LoginPage from "./pages/auth/login";
import LogoutPage from "./pages/auth/logout";
import RegisterPage from "./pages/auth/register";
import AuthLayout from "./pages/authLayout";
import CalibrateUser from "./pages/calibrate";
import Layout from "./pages/layout";
import LeagueOnUpListingPage from "./pages/league/leagueOnUpComingListingPage";
import LeagueMatching from "./pages/league/leagueMatching";
import LeagueMatchingConfirmResultPage from "./pages/league/leagueMatchingConfirmResult";
import LeagueMatchingSubmitPage from "./pages/league/LeagueMatchingSubmitPage";
import MyQR from "./pages/QR/myQR";
import ScanQR from "./pages/QR/scanQR";
import ScanQRJoinedLeagueListing from "./pages/QR/scanQRJoinedLeagueListing";
import ScanQRSelection from "./pages/QR/scanQRSelection";
import Profile from "./pages/user/profile";
import RankingHistory from "./pages/user/rankingHistory";
import RankingUser from "./pages/user/rankingUser";
import LeagueMatchHistory from "./pages/league/league-detail/history";
import LeagueEndedListing from "./pages/league/leagueEndedListing";
import HomePage from "./pages/home";
import LivePage from "./pages/live";
import RankingsPage from "./pages/rankings";
import SwissLeaguePage from "./pages/league/swiss";
import DeLeaguePage from "./pages/league/de";
import NewsListingPage from "./pages/news";
import NewsDetailPage from "./pages/news/detail";
import VenuePage from "./pages/venue";
import VenueListPage from "./pages/venue/list";

const routeVariants: Variants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
};

const routes: RouteObject[] = [
  {
    path: "league-public/:id",
    element: <LeaguePublic />,
  },
  // Tin tức nằm ngoài Layout: Layout đá người chưa đăng nhập về /auth/login, mà
  // đây đúng là những trang được chia sẻ ra ngoài cho người chưa có tài khoản đọc.
  {
    path: "news",
    element: <NewsListingPage />,
  },
  // Trang giới thiệu quán cũng nằm ngoài Layout, và cũng vì lý do đó: đây là
  // trang gửi cho khách chưa có tài khoản.
  {
    path: "venue",
    element: <VenueListPage />,
  },
  {
    path: "venue/:venueId",
    element: <VenuePage />,
  },
  {
    path: "news/:slug",
    element: <NewsDetailPage />,
  },
  {
    path: "auth",
    element: <AuthLayout />,
    children: [
      {
        path: "login",
        element: <LoginPage />,
        index: true,
      },
      {
        path: "logout",
        element: <LogoutPage />,
        index: false,
      },
      {
        path: "forgot-password",
        element: <ForgotPasswordPage />,
      },
      {
        path: "register",
        element: <RegisterPage />,
      },
    ],
  },
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <HomePage />,
        index: true,
      },
      {
        path: "live",
        element: <LivePage />,
      },
      {
        path: "bxh",
        element: <RankingsPage />,
      },
      {
        path: "my-qr",
        element: <MyQR />,
      },
      {
        path: "profile",
        element: <Profile />,
        index: true,
      },
      {
        path: "scan-qr-selection",
        element: <ScanQRSelection />,
      },
      {
        path: "scan-qr-selection/:mode",
        element: <ScanQRSelection />,
      },
      {
        path: "scan-qr-joined-league",
        element: <ScanQRJoinedLeagueListing />,
      },
      {
        path: "scan-qr",
        element: <ScanQR />,
      },
      {
        path: "scan-qr/:mode",
        element: <ScanQR />,
      },
      {
        path: "league",
        element: <LeagueOnUpListingPage />,
      },
      {
        // Demo harness only (mô phỏng, không backend). Giải Swiss thật render
        // trong /league/:id và /league/:id/detail theo league.type === 'SWISS'.
        path: "league-swiss",
        element: <SwissLeaguePage />,
      },
      {
        /* Giải Đấu kép thật render trong /league/:id và /league/:id/detail theo
           league.type === 'DOUBLE-ELIMINATION'. Đường này chỉ là chỗ hạ cánh. */
        path: "league-de",
        element: <DeLeaguePage />,
      },
      {
        path: "league-end",
        element: <LeagueEndedListing />,
      },
      {
        path: "league/:id",
        element: <LeagueDetail />,
      },
      {
        path: "league/:id/history",
        element: <LeagueMatchHistory />,
      },
      {
        path: "league/playoff/:id/schedule",
        element: <PlayoffAllSchedule />,
      },
      {
        path: "league/:id/detail/:playerId",
        element: <UserLeagueSchedule />,
      },
      {
        path: "league/:id/detail",
        element: <LeagueStandingPage />,
      },
      {
        path: "league/:leagueId/competitor/:playerId",
        element: <LeagueMatching />,
      },
      {
        path: "league/:leagueId/competitor/:playerId/match/:matchId",
        element: <LeagueMatching />,
      },
      {
        path: "league/:leagueId/match/:matchId",
        element: <LeagueMatchingSubmitPage />,
      },
      {
        path: "league/:leagueId/match/:matchId/result",
        element: <LeagueMatchingConfirmResultPage />,
      },
      {
        path: "calibrate/:id",
        element: <CalibrateUser />,
      },
      {
        path: "ranking/:id",
        element: <RankingUser />,
      },
      {
        path: "/profile/rank-history",
        element: <RankingHistory />,
      },
    ],
  },
];

// Route cha không path, không element (tự render <Outlet />) chỉ để gắn
// errorElement chung: thiếu nó react-router hiện trang stack trace mặc định
// "Unexpected Application Error!" cho người dùng.
export const router = createBrowserRouter([
  {
    errorElement: <RouteErrorPage />,
    children: routes,
  },
]);
